import { jsx as e } from "react/jsx-runtime";
import { c as r } from "../index-Cu0xwYjD.js";
import * as g from "react";
const m = "_pageWrapper_ipa4d_1", W = "_pageWrapperInner_ipa4d_5", p = {
  pageWrapper: m,
  pageWrapperInner: W
}, i = g.forwardRef(
  ({ backgroundColor: a, children: s, innerClassName: n, className: o, ...t }, c) => /* @__PURE__ */ e(
    "div",
    {
      ref: c,
      className: r(o, p.pageWrapper),
      style: { backgroundColor: a },
      ...t,
      children: /* @__PURE__ */ e(
        "section",
        {
          className: r(n, p.pageWrapperInner),
          children: s
        }
      )
    }
  )
);
i.displayName = "PageWrapper";
export {
  i as PageWrapper
};
